export default "__VITE_ASSET__DoSKBJx$__"